export function isEmptyObject(obj: any) {
  return !obj
    || Object.keys(obj).length === 0
    || Object.getPrototypeOf(obj) !== Object.prototype;
}
